// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "wrapper-XLB9e";
export { _1 as "__esModule", _2 as "wrapper" }
export default { "__esModule": _1, "wrapper": _2 }
